module.exports = __webpack_public_path__ + "static/media/01.78b31fb1.jpg";